export enum EnrollmentScoreEnum {
  BEGINNER = 'BEGINNER',
  ELEMENTARY = 'ELEMENTARY',
  PRE_INTERMEDIATE = 'PRE_INTERMEDIATE',
  INTERMEDIATE = 'INTERMEDIATE',
  UPPER_INTERMEDIATE = 'UPPER_INTERMEDIATE',
  ADVANCED = 'ADVANCED'
}

export const enrollmentScoreEnumMapping: Record<
  EnrollmentScoreEnum,
  { label: string; code: string }
> = {
  [EnrollmentScoreEnum.ADVANCED]: { label: 'Advanced', code: 'C1' },
  [EnrollmentScoreEnum.UPPER_INTERMEDIATE]: { label: 'Upper Intermediate', code: 'B2' },
  [EnrollmentScoreEnum.INTERMEDIATE]: { label: 'Intermediate', code: 'B1' },
  [EnrollmentScoreEnum.PRE_INTERMEDIATE]: { label: 'Pre-intermediate', code: 'A2' },
  [EnrollmentScoreEnum.ELEMENTARY]: { label: 'Elementary', code: 'A1' },
  [EnrollmentScoreEnum.BEGINNER]: { label: 'Beginner', code: 'Pre A1' }
}
